// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"f084e044","233":"6f7e4139","255":"d259f84d","567":"9af5ca38","858":"4e9b5ab7","948":"61758bdc","969":"b8b0bb12"}[chunkId] + ".chunk.css";
};